<template>
    <div>
        <transition name="fade">
            <router-view></router-view>
        </transition>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        props: {
            branchId: Number,
            fileId: Number,
            kaClaimNumber: String,
            insuredCompany: String,
            isAdmin: Boolean,
            currentUser: String,
            currentUserBranchId: Number,
            timezone: String,
            folderUrl: String,
            isClosed: Boolean,
            isWholeFoodsParentIncident: Boolean,
            startPage: Number,
            claimAdjuster: String,
            isOutlook: Boolean,
            fileToBeAudited: Boolean,
            keaUrl: String,
            isBillingReview: Boolean,
            newEntryDate: String,
            goToTeId: Number,
            lastReportNumber: Number,
            reportCycle: Number,
            abeyanceOffset: Number
        },
        created() {
            // created gets called twice (it may be caused by vue-router).
            // the 2nd time it gets called the props coming from Razor are undefined
            if (this.fileId !== undefined) {
                this.$store.state.branchId = this.branchId;
                this.$store.state.fileId = this.fileId;
                this.$store.state.kaClaimNumber = this.kaClaimNumber;
                this.$store.state.insuredCompany = this.insuredCompany;
                this.$store.state.isAdmin = this.isAdmin;
                this.$store.state.isClosed = this.isClosed;
                this.$store.state.currentUser = this.currentUser;
                this.$store.state.defaultUser = this.currentUser;
                this.$store.state.claimAdjuster = this.claimAdjuster;
                this.$store.state.currentUserBranchId = this.currentUserBranchId;
                this.$store.state.userTimezone = this.timezone;
                this.$store.state.folderUrl = this.folderUrl;
                this.$store.state.isClosed = this.isClosed;
                this.$store.state.isWholeFoodsParentIncident = this.isWholeFoodsParentIncident;
                this.$store.state.startPage = this.startPage;
                this.$store.state.isBillingReview = this.isBillingReview;
                if (this.newEntryDate && this.newEntryDate.length) {
                    this.$store.state.newEntryDate = Date.parse(this.newEntryDate);
                }
                this.$store.state.goToTeId = this.goToTeId;
                var outlookTEOptions = JSON.parse(sessionStorage.getItem('outlookTEOptions'));
                if (outlookTEOptions != null) {
                    this.$store.state.accessToken = outlookTEOptions.accessToken;
                    this.$store.state.comment = outlookTEOptions.comment;
                    this.$store.state.noteText = outlookTEOptions.noteText;
                    this.$store.state.emailTo = outlookTEOptions.emailTo;
                    this.$store.state.emailFrom = outlookTEOptions.emailFrom;
                    this.$store.state.isSentItems = outlookTEOptions.isSentItems;
                }
                this.$store.state.keaUrl = this.keaUrl;
                this.$store.state.fileToBeAudited = this.fileToBeAudited;
                this.$store.state.lastReportNumber = this.lastReportNumber;
                this.$store.state.fileReportCycle = this.reportCycle;
                this.$store.state.reportCycle = this.reportCycle;
                this.$store.state.abeyanceOffset = this.abeyanceOffset;
            }
        }
    };
</script>

<style lang="scss">
    @import "../../../node_modules/vue-loading-overlay/dist/vue-loading.min.css";
    @import "~vue-snotify/styles/material.css";

    .snotify-centerTop {

        top: 28px;

        .snotifyToast {
            border: 1px solid #CCCCCC;
        }
    }

    .snotify-success {
        background-color: #96A03B;

        .snotifyToast__body {
            color: #fff;
        }
    }
</style>
